import { Button, Text } from '@querodelivery/uni-react';
import { useNavigate } from 'react-router-dom';
import QueroLogLogo from '../../Assets/Img/quero-log-logo.svg';
import NotFoundImage from '../../Assets/Img/not-found-img.png';
import styles from './not-found.module.scss';

export const NotFound = () => {
  const navigate = useNavigate();

  const handleNavigateToHome = () => {
    navigate('/');
  };

  return (
    <div className={styles.container}>
      <div className={styles.leftContent}>
        <div className={styles.logo}>
          <img className={styles.imgLogo} src={QueroLogLogo} alt="Not Found" />
        </div>
        <div className={styles.textContent}>
          <Text tone="highlight" fontWeight="bold" className={styles.text404}>
            404
          </Text>
          <Text tone="secondary" fontSize="xxxl" fontWeight="bold">
            Página não encontrada
          </Text>
          <Text tone="secondary" fontSize="md" fontWeight="medium">
            Ops! A página que você está procurando não existe ou foi movida para
            outro lugar
          </Text>
          <Button onClick={handleNavigateToHome} variant="cta" size="xl">
            voltar para a página inicial
          </Button>
        </div>
        <div />
      </div>
      <img src={NotFoundImage} alt="Not Found" className={styles.imgContent} />
    </div>
  );
};
